<template>
  <div class="page">
    <Frame>
    <template v-slot:header>
      <CustomHeader
        v-if="hasNavHeader"
        :left-arrow="true"
        left-text="访客记录"
        :theme-vars="themeVars"
      />
    </template>
    <template v-slot:body>
      <div class="body-content">
        <div class="module-wrapper">
          <div
            class="qr-code"
            v-if="detail && detail.qrCodeVo && detail.qrCodeVo.sourceCode"
          >
            <div class="header">
              <div class="label">访客：{{ detail.personName }}</div>
              <div class="status">
                <van-image
                  v-if="
                    detail.actualDirection ||
                    String(detail.actualDirection) == '0'
                  "
                  width="54"
                  height="54"
                  radius="4px"
                  :src="
                    require(`@/assets/image/visitorRecord/${
                      actualDirectionLabels[detail.actualDirection].imgName
                    }.png`)
                  "
                />
              </div>
            </div>
            <div class="body">
              <div class="code-box">
                <div class="qr" :class="isLoseEfficacy ? 'lose-efficacy' : ''">
                  <vue-qr
                    :text="detail.qrCodeVo.sourceCode"
                    :size="240"
                  ></vue-qr>
                </div>
                <p class="time">
                  <span class="text">{{ detail.applicationDate }}</span>
                  <span class="remark">{{
                    detail.applicationDate ? "(当天有效)" : ""
                  }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="module-wrapper">
          <div :class="[isFold ? 'fold' : 'un_fold']">
            <div class="module">
              <div
                class="item apply-info"
                :class="[
                  !detail || !detail.qrCodeVo || !detail.qrCodeVo.sourceCode
                    ? 'status-img'
                    : '',
                ]"
              >
                <div class="label">
                  申请信息
                  <span class="visitor-type">{{
                    detail.peopleType == 2 ? "(白名单访客)" : "(正常访客)"
                  }}</span>
                </div>
                <div class="content">
                  <van-image
                    v-if="
                      (detail.actualDirection ||
                        String(detail.actualDirection) == '0') &&
                      (!detail ||
                        !detail.qrCodeVo ||
                        !detail.qrCodeVo.sourceCode)
                    "
                    width="54"
                    height="54"
                    radius="4px"
                    :src="
                      require(`@/assets/image/visitorRecord/${
                        actualDirectionLabels[detail.actualDirection].imgName
                      }.png`)
                    "
                  />
                </div>
              </div>
            </div>
            <div class="module">
              <div class="item">
                <div class="label">访问类型：</div>
                <div class="content">
                  <div class="text">
                    {{ detail.appointmentDictionaryName }}
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="label">访客姓名：</div>
                <div class="content">
                  <div class="text">{{ detail.personName }}</div>
                </div>
              </div>
              <div class="item">
                <div class="label">访客手机号：</div>
                <div class="content">
                  <div class="text">{{ detail.phone }}</div>
                </div>
              </div>

              <div class="item" v-if="detail.peopleType !== 2">
                <div class="label">预约拜访时间：</div>
                <div class="content">
                  <div class="text">{{ detail.applicationDate }}</div>
                </div>
              </div>
              <div class="item">
                <div class="label">备注说明：</div>
                <div class="content">
                  <div class="text">{{ detail.remark }}</div>
                </div>
              </div>
              <div class="item">
                <div class="label">拜访对象：</div>
                <div class="content">
                  <div class="text">{{ detail.intervieweePersonName }}</div>
                </div>
              </div>
              <div class="item">
                <div class="label">拜访对象手机号：</div>
                <div class="content">
                  <div class="text">{{ detail.intervieweePhone }}</div>
                </div>
              </div>
              <div class="item">
                <div class="label">访客性别：</div>
                <div class="content">
                  <div class="text">{{ detail.sex || "暂无" }}</div>
                </div>
              </div>
              <div class="item">
                <div class="label">访客身份证号：</div>
                <div class="content">
                  <div class="text">{{ detail.idNumber }}</div>
                </div>
              </div>

              <div class="item" v-if="detail.faceUrl">
                <div class="label">访客人脸：</div>
                <div class="content">
                  <div class="img">
                    <van-image
                      width="32"
                      height="32"
                      radius="4px"
                      :src="FILEBASEURL + detail.faceUrl"
                      @click="imagePreviewEvt(FILEBASEURL + detail.faceUrl)"
                    />
                  </div>
                </div>
              </div>
              <div class="item" v-if="detail.healthCodeUrl">
                <div class="label">访客健康码：</div>
                <div class="content">
                  <div class="img">
                    <van-image
                      width="32"
                      height="32"
                      radius="4px"
                      :src="FILEBASEURL + detail.healthCodeUrl"
                      @click="
                        imagePreviewEvt(FILEBASEURL + detail.healthCodeUrl)
                      "
                    />
                  </div>
                </div>
              </div>
              <div class="item" v-if="detail.travelCodeUrl">
                <div class="label">访客行程码：</div>
                <div class="content">
                  <div class="img">
                    <van-image
                      width="32"
                      height="32"
                      radius="4px"
                      :src="FILEBASEURL + detail.travelCodeUrl"
                      @click="
                        imagePreviewEvt(FILEBASEURL + detail.travelCodeUrl)
                      "
                    />
                  </div>
                </div>
              </div>

              <div class="item" v-if="detail.peopleSum">
                <div class="label">访客同行人数：</div>
                <div class="content">
                  <div class="text">{{ detail.peopleSum }}</div>
                </div>
              </div>
              <div class="item" v-if="detail.carCode">
                <div class="label">访客车牌信息：</div>
                <div class="content">
                  <div class="text">{{ detail.carCode }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="fold-bar" @click="toggleEvt">
            {{ isFold ? "展开" : "收起" }}
            <van-icon :name="isFold ? 'arrow-down' : 'arrow-up'" />
          </div>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div
        class="footer"
        v-if="userType == 'teacher' && String(detail.actualDirection) === '0'"
      >
        <van-button
          class="van-button"
          plain
          round
          type="primary"
          @click="toRefusePage"
          >拒绝</van-button
        >
        <van-button class="van-button" round type="primary" @click="toAgreePage"
          >同意</van-button
        >
      </div>
    </template>
  </Frame>
  </div>
</template>

<script>
import Frame from "@/components/frame.vue";
import CustomHeader from "@/components/customHeader/index.vue";
import VueQr from "vue-qr/src/packages/vue-qr.vue";
import { Toast } from "vant";
import { ImagePreview } from "vant";

import { computed, ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
export default {
  name: "VisitorRecordDetail",
  components: {
    Frame,
    CustomHeader,
    VueQr,
  },
  setup() {
    const FILEBASEURL = ref(process.env.VUE_APP_BASE_File_URL);
    //   自定义主题
    const themeVars = {
      navBarTextColor: "#333",
    };

    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const hasNavHeader = computed(() => store.getters.hasNavHeader);
    const plateformType = computed(() => store.getters.plateformType);
    const schoolCode = computed(() => store.state.schoolCode);
    const userType = computed(() => store.state.userType);
    const idNumber = computed(() => store.state.idNumber);
    const phone = computed(() => store.state.phone);

    const id = route.query.id || "";

    const detail = ref({});
    const isFold = ref(true);
    // 混合进出审批类型：0待审批，1已拒绝，2未拜访，4已拜访，5已过期
    const actualDirectionLabels = ref({
      0: {
        label: "待审批",
        className: "un-approve",
        imgName: "unApprove",
      },
      1: {
        label: "已拒绝",
        className: "refused",
        imgName: "refused",
      },
      2: {
        label: "未拜访",
        className: "un-visited",
        imgName: "unVisited",
      },
      4: {
        label: "已拜访",
        className: "visited",
        imgName: "visited",
      },
      5: {
        label: "已过期",
        className: "expired",
        imgName: "expired",
      },
      500: {
        label: "",
        className: "",
        imgName: "",
      },
    });

    const openAutoInfo = (params) =>
      store.dispatch("visitor/openAutoInfo", params);
    const teacherAppInfo = (params) =>
      store.dispatch("visitor/teacherAppInfo", params);
    const parentAppInfo = (params) =>
      store.dispatch("visitor/parentAppInfo", params);

    const getDetailData = async () => {
      if (!id) {
        Toast.fail("缺少id参数, 请返回重试！");
        return;
      }
      let params = {
        schoolCode: schoolCode.value,
        idNumber: idNumber.value,
        phone: phone.value,
        id: id,
      };

      let r = null;
      if (
        plateformType.value === "DingTalkMini" ||
        plateformType.value === "WeChatMiniProgram"
      ) {
        if (userType.value === "teacher") {
          r = await teacherAppInfo(params);
        } else {
          r = await parentAppInfo(params);
        }
      } else {
        r = await openAutoInfo(params);
      }

      let { success, data, message } = r || {};
      if (success) {
        detail.value = data || {};
      } else {
        Toast.fail(message);
      }
    };
    getDetailData();

    const toggleEvt = () => {
      isFold.value = !isFold.value;
    };

    const toRefusePage = () => {
      router.push({
        path: "/visitorRefuseApply",
        query: {
          id: detail.value.id,
        },
      });
    };
    const toAgreePage = () => {
      router.push({
        path: "/visitorAgreeApply",
        query: {
          id: detail.value.id,
        },
      });
    };

    const imagePreviewEvt = (url) => {
      ImagePreview([url]);
    };

    return {
      FILEBASEURL,
      themeVars,
      hasNavHeader,
      actualDirectionLabels,
      plateformType,
      userType,
      schoolCode,
      getDetailData,
      detail,
      isFold,
      toggleEvt,
      toRefusePage,
      toAgreePage,
      imagePreviewEvt,
    };
  },
};
</script>

<style lang="less" scoped>
.page{
  height: 100vh;
}
.frame {
  background-color: #f2f4fa;
}
.body-content {
  position: relative;

  border-radius: 8px;
  .module-wrapper {
    text-align: center;
    border-radius: 16px;
    padding: 0px 12px;
    margin: 10px 15px;
    background-color: #fff;
    .fold {
      height: 300px;
      padding-top: 6px;
      overflow: hidden;
    }
    .un_fold {
      padding-top: 6px;
    }
  }
  .fold-bar {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 45px;
    color: #999;
    font-size: 15px;
    font-weight: 400;
    text-align: center;
  }
}
.module {
  .item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 44px;
    font-size: 15px;
    font-weight: 400;
    &.apply-info {
      color: #333;
      margin-bottom: 12px;
      font-weight: 600;
      .visitor-type {
        font-size: 12px;
        font-weight: 400;
      }
      &.status-img {
        height: 54px;
        margin: 6px auto;
      }
    }
    .label {
      color: #666;
    }
    .content {
      color: #666;
      .status {
        display: inline-block;
        border: 1px solid #ccc;
        padding: 2px 8px;
        border-radius: 2px;
        &.un-approve {
          color: rgba(255, 137, 72, 1);
          border-color: rgba(255, 137, 72, 1);
        }
        &.refused {
          color: rgba(254, 79, 84, 1);
          border-color: rgba(254, 79, 84, 1);
        }
        &.un-visited {
          color: rgba(66, 117, 253, 1);
          border-color: rgba(66, 117, 253, 1);
        }
        &.visited {
          color: rgba(60, 194, 81, 1);
          border-color: rgba(60, 194, 81, 1);
        }
        &.expired {
          color: rgba(153, 153, 153, 1);
          border-color: rgba(153, 153, 153, 1);
        }
      }
    }
  }
}
.qr-code {
  text-align: center;
  padding: 6px 16px;
  .header {
    display: flex;
    height: 54px;
    align-items: flex-start;
    justify-content: space-between;
    .label {
      margin-top: 10px;
    }
  }
  .time {
    text-align: center;
    font-size: 14px;
    color: #999;
    margin-top: -14px;
  }
}
.footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  padding: 6px 15px;
  .van-button {
    width: 150px;
    height: 36px;
  }
}
</style>
